import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    container: {
        position: "relative",
    },
    label: {
        position: 'absolute',
        fontSize: '12px',
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.common.white,
        top: -8,
        left: 10,
        padding: " 0 4px"
    },
    items_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: '4px',
        backgroundColor: theme.palette.common.white,
        marginTop: theme.spacing(1),
        minHeight: '60px',
        minWidth: "600px"
    },
    item_row: {
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'flex-start',
        padding: theme.spacing(1.5),
        backgroundColor: theme.palette.background.default,
        borderRadius: '4px',
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    article_select: {
        flex: 2,
    },
    amount_input: {
        flex: 1,
    },
    delete_button: {
        marginTop: "4px",
        color: theme.palette.error.main,
        "&:hover": {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.dark,
        },
    },
    add_button: {
        marginTop: theme.spacing(1),
    },
    disabled: {
        opacity: 0.6,
        pointerEvents: 'none',
        cursor: 'not-allowed',
    },
    add_btn_container: {
        width: "100%",
        display: "flex",
        justifyContent: "end"
    }
}));

export { useStyles };
